import { useState, useEffect } from 'react';
import { useMutation } from 'react-apollo';
import { useDispatch } from 'react-redux';

import useEmailPinAuth from '../../../../components/auth/hooks/useEmailPinAuth';
import marketingAccountLinkMutation from '../mutations/marketing-account-link';
import { loginSuccess } from '../../../../actions/auth-actions';

const useMarketingAccountOnboarding = ({ emailAddress }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { onEmailAuthenticationRequest, onLoginByEmail } = useEmailPinAuth();
  const [marketingAccountLink] = useMutation(marketingAccountLinkMutation);

  const handleEmailAuthenticationRequest = async () => {
    setLoading(true);
    setError(null);
    try {
      await onEmailAuthenticationRequest({ emailAddress });
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (emailAddress) {
      handleEmailAuthenticationRequest();
    }
  }, [emailAddress]);

  const onPinVerify = async ({ code }) => {
    setLoading(true);
    setError(null);
    try {
      const result = await onLoginByEmail({ emailAddress, code });
      if (result?.data?.accountLoginByEmail?.success) {
        dispatch(loginSuccess());
      }
      return result;
    } catch (e) {
      setError(e.message);
      throw e;
    } finally {
      setLoading(false);
    }
  };

  const onPinCodeResend = async () => {
    await handleEmailAuthenticationRequest();
  };

  const onMarketingAccountLink = async marketingAccountId => {
    setLoading(true);
    setError(null);
    try {
      await marketingAccountLink({
        variables: {
          input: {
            marketing_account_id: marketingAccountId,
          },
        },
      });
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    onPinVerify,
    onPinCodeResend,
    onMarketingAccountLink,
  };
};

export default useMarketingAccountOnboarding;
